import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Hero from '../components/Home/Hero'

import ManualSection from '../components/Home/ManualSection'


import Footer from '../components/Footer/Footer'

import Footerhero from '../components/Footer/Footerhero'
import WhyChoose from '../components/Home/WhyChoose'

import Impact from '../components/Home/Impact'

const Homepage = () => {
    return (
        <div>
            <Navbar />
            <Hero />
            <Impact />
            <ManualSection />
            <WhyChoose />





            <Footerhero />
            <Footer />

        </div>
    )
}

export default Homepage